module.exports = __webpack_public_path__ + "img/target002.ef31b607.png";